import { createFileRoute } from "@tanstack/react-router";

import PasswordResetPage from "@/components/Password/PasswordResetPage";

export const Route = createFileRoute("/_auth/account/password/reset")({
  component: PasswordResetPage,
});
